import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, onMounted, ref } from 'vue';
import { provideSeededUuidGenerator, uuidGeneratorProviderKey } from 'JS/composables/uuid';


export default /*#__PURE__*/_defineComponent({
  __name: 'SsrRoot',
  props: {
    kind: null,
    data: null
  },
  setup(__props: any) {

const props = __props as {
	kind: string;
	data?: unknown;
}



const mounted = ref(false);
onMounted(() => mounted.value = true);

// put the page into a data attribute during SSR so that the client can pick it up and pass it back in during hydration
const hydrationData = computed(() => {
	if (typeof props.data === 'undefined' || mounted.value) {
		return undefined;
	}

	return JSON.stringify(props.data);
});

// NOTE: intentionally non-reactive
const uuidSeed = typeof props.data === 'undefined'
	? props.kind
	: props.kind + JSON.stringify(props.data);

// allow override in case the namespace/seed generated here isn't unique enough.
// situations like renderer multiple copies of the same SSR'd app with no data or with the same data.
const uuidGeneratorOverride = inject(uuidGeneratorProviderKey, undefined);
if (!uuidGeneratorOverride) {
	provideSeededUuidGenerator(uuidSeed);
}


return { __sfc: true,props, mounted, hydrationData, uuidSeed, uuidGeneratorOverride }
}

})